/* --- Blockquote --- */

	function blockquoteSetup(){
		var blockquotes = document.getElementsByTagName('blockquote');
		// Hide them all and store them in an Array
		for (var i = blockquotes.length - 1; i >= 0; i--) {
			blockquotes[i].classList.add('hidden');
		}
	}

	var blockquote = throttle(function (){

		var blockquotes = document.getElementsByTagName('blockquote');

		// Go trough all of the blockquotes
		for (var i = blockquotes.length - 1; i >= 0; i--) {

			// Check if the blockquote is hidden
			if( blockquotes[i].classList.contains('hidden') ){

				// Check if the blockquote is 8% from the bottom
				if( blockquotes[i].getBoundingClientRect().top < (window.innerHeight * .92) ){

					// Then make the blockquote visible
					blockquotes[i].classList.remove('hidden');
				}

			} // The blockquote was hidden

		} // End for

	}, 100);

/* --- End - Blockquote --- */
